"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnlineStatus = exports.registerOnlineStatus = exports.hasStorage = exports.getStorage = exports.registerStorage = void 0;
let _storage = null;
let _onlineStatus = null;
/**
 * Register the platform-specific storage implementation.
 * Must be called once at app startup before any shared service
 * accesses storage.
 */
function registerStorage(storage) {
    _storage = storage;
}
exports.registerStorage = registerStorage;
/**
 * Get the registered storage. Throws if not registered.
 */
function getStorage() {
    if (!_storage) {
        throw new Error('Storage not registered. Call registerStorage() at app startup ' +
            'with a platform-specific IStorage implementation.');
    }
    return _storage;
}
exports.getStorage = getStorage;
/**
 * Check if storage has been registered (for optional usage).
 */
function hasStorage() {
    return _storage !== null;
}
exports.hasStorage = hasStorage;
/**
 * Register the platform-specific online status implementation.
 */
function registerOnlineStatus(onlineStatus) {
    _onlineStatus = onlineStatus;
}
exports.registerOnlineStatus = registerOnlineStatus;
/**
 * Get the registered online status. Returns a default (always online)
 * if not registered.
 */
function getOnlineStatus() {
    if (!_onlineStatus) {
        // Default: always online
        return {
            isOnline: () => true,
            subscribe: () => () => { },
        };
    }
    return _onlineStatus;
}
exports.getOnlineStatus = getOnlineStatus;
